import Decimal from 'decimal.js';

export function hasAtMostNDecimals(num: number, decimals: number): boolean {
  if (!Number.isFinite(num)) {
    return false;
  }
  const decimal = new Decimal(num);
  return decimal.decimalPlaces() <= decimals;
}
